
// Appends cart value when download version is selected


const swal = require('sweetalert2');

$(document).ready(() => {
    //this portion of the script requires the user to select at least x number of checkboxes 
    $('#Order').submit((e) => {
        //get all checkboxes with a class of 'checkboxclass'
        var checked = $('.checkboxclass').filter(':checked');
        var num_checked = checked.length;
        var format = e.target.format.value;
        for (var i = 0; i < checked.length; i++) {
            var checkbox = checked[i];
            const parts = checkbox.value.split("^");
            if (format === "physical") {
                parts[1] = parts[1].trim().replace(/^(=SF=)?OP/, '');
                parts[2] = parts[2].trim().replace(/ - Download Version$/, '');
            } else {
                parts[1] = parts[1].trim().replace(/^(=SF=)?(OP)?/, '=SF=OP');
                parts[2] = parts[2].trim().replace(/( - Download Version)?$/, ' - Download Version');
            }
            checked[i].value = parts.join("^");
        }

        if (num_checked < 1) {
            swal('Please make your selection', 'Woops! Please make your selection.');
            return false;
        }
        
    });
});